export const SAAS_PLAN = {
  id: "SAAS",
  title: "Smartbooks",
  price: 25,
  currency: "EUR",
  interval: "month"
};

export const SAAS_TRIAL_DAYS = 14;

/** Boxx Finglas is the only unpaid book. Its tenant id is `boxx`. */
const PROTECTED_TENANT_IDS = ["boxx-finglas", "boxx"];

export function isProtectedTenantId(id) {
  if (!id) return false;
  const value = String(id).toLowerCase();
  if (PROTECTED_TENANT_IDS.indexOf(value) !== -1) return true;
  return value.indexOf("boxx-") === 0;
}

function collectTenantIds({ uid, storeId, tenantId, shop } = {}) {
  return [
    uid,
    storeId,
    tenantId,
    shop && shop._id,
    shop && shop.storeId,
    shop && shop.tenantId
  ];
}

export function isProtectedTenant(args) {
  return collectTenantIds(args).some(isProtectedTenantId);
}

/**
 * Every provisioned book except Boxx Finglas is on Stripe SaaS.
 */
export function isSaasOwner(args) {
  const src = args || {};
  if (isProtectedTenant(src)) return false;
  if (!src.uid) return false;
  const storeId = src.storeId || (src.shop && (src.shop._id || src.shop.storeId));
  const tenantId = src.tenantId || (src.shop && src.shop.tenantId);
  return !!(storeId || tenantId);
}

export function todayYmd(now) {
  const date = now ? new Date(now) : new Date();
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");
  return `${date.getFullYear()}-${month}-${day}`;
}

export function endDateYmd(endDate) {
  if (!endDate) return "";
  return String(endDate).slice(0, 10);
}

export function isSubscriptionExpired(subscription, now) {
  const end = endDateYmd(subscription && subscription.endDate);
  if (!end) return true;
  return todayYmd(now) > end;
}

export function hasActiveSubscriptionAccess(subscription, now) {
  if (!subscription) return false;
  if (isSubscriptionExpired(subscription, now)) return false;
  return !!(
    subscription.trialPeriod ||
    subscription.plan ||
    subscription.stripeSubscription
  );
}

/** A new trial only if this tenant has never had a period. */
export function canStartSaasTrial(subscription) {
  if (!subscription) return true;
  if (
    subscription.endDate ||
    subscription.trialPeriod ||
    subscription.plan ||
    subscription.stripeSubscription
  ) {
    return false;
  }
  return true;
}

export function billingRequired({
  uid,
  storeId,
  tenantId,
  shop,
  subscription,
  subscriptionLoaded
}) {
  if (!uid) return false;
  if (isProtectedTenant({ uid, storeId, tenantId, shop })) return false;
  if (!subscriptionLoaded) return false;
  if (!storeId && !tenantId && !(shop && (shop._id || shop.storeId))) {
    return false;
  }
  return !hasActiveSubscriptionAccess(subscription);
}

export function saasSubscriptionView(subscription) {
  const sub = subscription || {};
  return {
    planId: sub.plan === "SAAS" ? "SAAS" : sub.plan || "SAAS",
    title: SAAS_PLAN.title,
    price: SAAS_PLAN.price,
    trialPeriod: !!sub.trialPeriod,
    cancelled: !!sub.cancelledDate,
    endDate: sub.endDate || null,
    active: !!sub.stripeSubscription && !sub.cancelledDate,
    usable: hasActiveSubscriptionAccess(sub)
  };
}
